import React, { useState } from 'react';
import { FREE_TRIAL_URL } from '../../consts/urls';
import { useGlobalContext } from '../GlobalContextProvider/GlobalContextProvider';
import StaticImage from '../StaticImage';
import UniversalLink from '../UniversalLink/UniversalLink';
import {
  BoldParagraph,
  ButtonLabel,
  ButtonsBlock,
  ButtonWrapper,
  CircleList,
  CircleListItem,
  FreeTrialButton,
  GatedBlockContainer,
  GradientBlock,
  LoginButton,
  TextBlock,
  ClassicTryItBlock,
  ClassicTryItText,
} from './GatedBlock.styled';

const laptopImage = '/img/laptop-img.jpg';

const GatedBlock = ({ isHigher = false }) => {
  const [csrfToken] = useState(null);
  const { user, currentHref } = useGlobalContext();
  return (
    <GatedBlockContainer $isHigher={isHigher}>
      <GradientBlock />
      <ButtonsBlock>
        {!user && (
          <ButtonWrapper>
            <ButtonLabel>Please log in to continue reading.</ButtonLabel>
            <form>
              <input
                type='hidden'
                name='csrfmiddlewaretoken'
                value={csrfToken || ''}
              />
              <input type='hidden' name='next' value={currentHref || ''} />

              <LoginButton
                formMethod='get'
                formAction='/accounts/auth0/login/'
                type='submit'
              >
                Log in
              </LoginButton>
            </form>
          </ButtonWrapper>
        )}
        <ButtonWrapper>
          <ButtonLabel>Not yet a subscriber? Take a free trial.</ButtonLabel>
          <UniversalLink href={FREE_TRIAL_URL}>
            <FreeTrialButton>Start a free trial</FreeTrialButton>
          </UniversalLink>
        </ButtonWrapper>
      </ButtonsBlock>
      <TextBlock>
        <BoldParagraph>
          Military Periscope gives you easy-to-use, integrated, open-source
          intelligence on…
        </BoldParagraph>
        <CircleList>
          <CircleListItem>
            More than <b>7,500 weapons systems</b> and platforms
          </CircleListItem>
          <CircleListItem>
            Nearly every country&#39;s <b>armed forces</b>
          </CircleListItem>
          <CircleListItem>
            <b>Militant organizations</b>
          </CircleListItem>
        </CircleList>
      </TextBlock>
      <ClassicTryItBlock>
        <StaticImage
          width={802}
          height={445}
          alt='laptop image'
          src={laptopImage}
          quality={100}
        />
        <ClassicTryItText>
          Try Military Periscope free for seven days
        </ClassicTryItText>
        <UniversalLink href={FREE_TRIAL_URL}>
          <FreeTrialButton>Start a Free Trial</FreeTrialButton>
        </UniversalLink>
      </ClassicTryItBlock>
    </GatedBlockContainer>
  );
};

export default GatedBlock;
